import axios from "axios"
import { toast } from 'react-toastify';
import { getToken } from './Helper';

// Helper: fetch with timeout
function fetchWithTimeout(url, options = {}, timeout = 5000) {
	return new Promise((resolve, reject) => {
		const timer = setTimeout(() => reject(new Error("Timeout")), timeout);
		fetch(url, options)
			.then((response) => {
				clearTimeout(timer);
				resolve(response);
			})
			.catch((err) => {
				clearTimeout(timer);
				reject(err);
			});
	});
}

async function getClientIP() {
	if(sessionStorage.getItem('clientIp')){
		return sessionStorage.getItem('clientIp');
	}
	const fallbackAPIs = [
		{ url: 'https://api.ipify.org?format=json', key: 'ip' },
		{ url: 'https://ipwho.is/', key: 'ip' },
	];

	for (const api of fallbackAPIs) {
		try {
			const res = await fetchWithTimeout(api.url, {}, 2000); // 3-second timeout
			if (!res.ok) throw new Error(`Fetch failed from ${api.url}`);
			const data = await res.json();
			const ip = data[api.key];
			if (ip) {
				sessionStorage.setItem('clientIp', ip);
				return ip;
			}
		} catch (err) {
			console.warn(`IP fetch failed from ${api.url}:`, err.message);
		}
	}

	console.error("All IP fetch attempts failed.");
	return '0.0.0.0';
}

const ip = await getClientIP();

const axiosApi = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	headers: {
		'X-Requested-With': 'XMLHttpRequest',
		'Content-Type': 'application/json',
		'appversion': '1.1',
		'X-Client-IP': ip
	},
	responseType: 'json',
})



export async function get(url, config = {}) {
	axiosApi.defaults.headers.Authorization = getToken();
	return await axiosApi.get(url, { ...config })
		.then(response => response.data)
		.catch(error => {
			// Check if it's a CORS or network error
			if (error.message === 'Network Error' && !error.response) {
				toast.error('A CORS error occurred. Please check if the server allows this origin.');
				window.location.href = '/logout';
			}

			if (error.response && error.response.status === 401) {
				window.location.href = '/logout';
			}
		})
}

export async function post(url, data, config = {}) {

	axiosApi.defaults.headers.Authorization = getToken();
	return axiosApi
		.post(url, { ...data }, { ...config })
		.then(response => response.data)
		.catch(error => {
			// Check if it's a CORS or network error
			if (error.message === 'Network Error' && !error.response) {
				toast.error('A CORS error occurred. Please check if the server allows this origin.');
				window.location.href = '/logout';
			}

			if (error.response && error.response.status === 401) {
				window.location.href = '/logout';
			}
		})
}

export async function multipart_post(url, data) {
	return axios({
		url: process.env.REACT_APP_API_URL + url,
		method: 'POST',
		data: data,
		headers: {
			'Content-Type': 'multipart/form-data',
			'Authorization': getToken()
		}
	})
		.then(response => response.data)
		.catch(error => {
			// Check if it's a CORS or network error
			if (error.message === 'Network Error' && !error.response) {
				toast.error('A CORS error occurred. Please check if the server allows this origin.');
				window.location.href = '/logout';
			}

			if (error.response && error.response.status === 401) {
				window.location.href = '/logout';
			}
		})
}

export async function put(url, data, config = {}) {
	axiosApi.defaults.headers.Authorization = getToken();
	return axiosApi
		.put(url, { ...data }, { ...config })
		.then(response => response.data)
		.catch(error => {
			// Check if it's a CORS or network error
			if (error.message === 'Network Error' && !error.response) {
				toast.error('A CORS error occurred. Please check if the server allows this origin.');
				window.location.href = '/logout';
			}

			if (error.response && error.response.status === 401) {
				window.location.href = '/logout';
			}
		})
}

export async function del(url, config = {}) {
	axiosApi.defaults.headers.Authorization = getToken();
	return await axiosApi
		.delete(url, { ...config })
		.then(response => response.data)
		.catch(error => {
			// Check if it's a CORS or network error
			if (error.message === 'Network Error' && !error.response) {
				toast.error('A CORS error occurred. Please check if the server allows this origin.');
				window.location.href = '/logout';
			}

			if (error.response && error.response.status === 401) {
				window.location.href = '/logout';
			}
		})
}